import { Button } from 'components/Button/Button'
import { useTranslation } from 'react-i18next'
import { ReactComponent as CaretIcon } from 'images/Icon_Caret.svg'

export interface ToggleCollapsibleCardsProps {
  onOpen: () => void,
  onClose: () => void
}

export const ToggleCollapsibleCards: React.FC<ToggleCollapsibleCardsProps> = ({ onOpen, onClose }) => {
  const { t } = useTranslation('premiumsMonthly')

  return (
    <div>
      <Button className="ds-u-text-decoration--none ds-c-button ds-c-button--ghost my-u-p--2" onClick={onOpen}>
        {t('toggleCollapsibleCards.open')}
        <CaretIcon
          className="my-c-caret--down my-c-caret--blue my-u-ml--6"
          aria-hidden
          focusable={false}
        />
      </Button>
      <Button className="ds-u-text-decoration--none ds-c-button ds-c-button--ghost my-u-p--2" onClick={onClose}>
        {t('toggleCollapsibleCards.close')}
        <CaretIcon
          className="my-c-caret--up my-c-caret--blue my-u-ml--6"
          aria-hidden
          focusable={false}
        />
      </Button>
    </div>
  )
}
